<template>
    <div class="header-return">
        <el-row :gutter="18">
            <couponM></couponM>

        </el-row>
    </div>
</template>

<script>
    import couponM from '@/components/coupon/coupon'
    import ElRow from "element-ui/packages/row/src/row";
    export default{
        components:{
            ElRow, couponM
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>

</style>


// WEBPACK FOOTER //
// src/views/coupon/coupon_tab.vue